var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"font-size":"14px","color":"#0b58a2"}},[_vm._v("Is App")])}
var staticRenderFns = []

export { render, staticRenderFns }